<template>
  <!--Team Section-->
  <el-skeleton :count="6" :loading="loading" animated></el-skeleton>
  <section  class="team-section wow fadeInUp animated">
    <div class="auto-container">
      <!-- <div class="sec-title with-separator centered">
        <h2>Tenders</h2>
        <div class="separator">
                    <span class="cir c-1"></span><span class="cir c-2"></span><span class="cir c-3"></span>
                </div>
                <div class="lower-text">Bidding Information</div>
      </div> -->

      <div class="sidebar-page-container">
        <div class="auto-container">
          <div class="row clearfix">
            <!--Content Side-->
            <div class="content-side col-lg-8 col-md-12 col-sm-12">
              <div class="content-inner" v-if="dataList.length > 0">
                <div class="events-list">
                  <!--Event Block-->
                  <div
                    class="event-block"
                    v-for="(item, index) in dataList"
                    :key="index"
                    @click="link_to(item.id)"
                    :class="item.columnId == 78 ? 'history' : ''"
										:style="dataList?.length == 1 ? 'border-bottom: 1px solid rgba(0, 0, 0, 0.07);':''"
                  >
                    <div class="inner-box">
                      <div class="content-box">
                        <span
                          class="icon iconfontali icon-New"
                          v-if="
                            type == 'PostponeAnnouncement' ||
                            item.postponeType == 1 ||
                            item.postponeType == 2
                          "
                        ></span>
                        <!-- <div class="public-date" v-if="item.columnId == 78">
                          <img src="/public/images/close.png" />
                        </div> -->
                        <div class="content">
                          <div class="cat-info">
                            <div class="time-zone">Tender No: {{ item.tenderNo }} &nbsp;&nbsp;</div>
                            <div class="location">
                              <div>
                                <!-- <span class="green icon iconfontali icon-gonggao"></span>  -->
                                Start Date:
                                <span>{{ moment(item.releaseDate).format('YYYY-MM-DD HH:mm') }}</span>
                              </div>
                            </div>
                            <div class="location">
                              <div>
                                <!-- <span class="red icon iconfontali icon-close"></span>  -->
                                Closing Date:
                                <span>{{ moment(item.endDate).format('YYYY-MM-DD HH:mm') }}</span>
                              </div>
                            </div>
                            <!-- <div>
                              {{ item.columnName }}
                            </div> -->
                          </div>
                          <h3>
                            {{ item.title }}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- v-if="type != 'all'" -->
                <!--分页-->
                <paper
                  :currentPage="Page.currentPage"
                  :pageSize="Page.pageSize"
                  :total="Page.total"
                  @onChange="currentChangeHandle"
                ></paper>
                <!-- Pagination -->
                <!-- <div class="pagination-box text-right" >
                 <ul class="styled-pagination">
                    <li class="prev">
                      <a href="javascript:void(0)" @click="prevPage"
                        ><span class="icon flaticon-arrows-1"></span> Prev</a
                      >
                    </li>
                    <li><a href="#" class="active">1</a></li>
                    <li><a href="#">2</a></li>
                    <li class="next">
                      <a href="javascript:void(0)" @click="prevPage"
                        >Next <span class="icon flaticon-right-2"></span
                      ></a>
                    </li>
                  </ul> 
                </div> -->
              </div>
							
            <el-empty v-if="dataList.length == 0" description="No more" image-size="168"></el-empty>
            </div>

            <!--Sidebar Side-->
            <div class="sidebar-side col-lg-4 col-md-12 col-sm-12">
              <aside class="sidebar">
                <div class="tab-title">Tender Announcement</div>
                <!-- <div class="bg-layer">
                            <div class="image-layer" style="background-image:url(images/background/sidebar-bg-image.jpg);"></div>
                        </div> -->

                <div class="sidebar-widget services-widget">
                  <div class="widget-content">
                    <ul class="links clearfix">
                      <!-- <li :class="type == 'all' ? 'current' : ''" @click="changeType('all')">
                        <div class="">
                          <span class="icon iconfontali icon-zhaotoubiaoxinxi1"></span>
                          <span class="ttl">Tender Announcement</span>
                        </div>
                      </li> -->
                      <li
                        :class="type == 'Bidding' ? 'current' : ''"
                        @click="changeType('Bidding')"
                      >
                        <div>
                          <span class="icon iconfontali icon-zhaotoubiaoxinxi"></span>
                          <span class="ttl">Bidding Information</span>
                        </div>
                      </li>
                      <li
                        :class="type == 'PostponeAnnouncement' ? 'current' : ''"
                        @click="changeType('PostponeAnnouncement')"
                      >
                        <div>
                          <span class="icon iconfontali icon-yanqi"></span>
                          <span class="ttl">Postpone Announcement</span>
                        </div>
                      </li>
                      <li
                        :class="type == 'History' ? 'current' : ''"
                        @click="changeType('History')"
                      >
                        <div>
                          <span class="icon iconfontali icon-guoqi"></span>
                          <span class="ttl">History Bidding Information</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="read-more">
                  <router-link to="/tenders/biddingInformation"
                    ><span class="icon flaticon-right-2"></span> &nbsp; Read More</router-link
                  >
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <div class="team-carousel owl-theme owl-carousel hide">
        <!--Team Block-->
        <div v-for="(item, index) in dataList" :key="item.id" class="team-block border">
          <div @click="link_to(item.id)" class="inner-box">
            <div class="image-box p-tb-50">
              <div>Tender No: {{ item.tenderNo }}</div>
              <div>
                {{ item.title }}
              </div>
              <div>Start Date: {{ item.releaseDate }}</div>
              <div>Closing Date: {{ item.endDate }}</div>
              <div class="hover-box">
                <div class="hover-inner">
                  <div class="hover-upper">
                    <div class="icon-box"><span class="flaticon-chat"></span></div>
                    <h6>Details</h6>
                  </div>
                  <div class="hover-lower">
                    <ul class="info">
                      <li><router-link to="/details?name=Tenders">Tender No</router-link></li>
                      <li>
                        <router-link to="/details?name=Tenders">{{ item.tenderNo }}</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="lower-box border-none">
              <h4>
                <router-link to="/details?name=Tenders">NO.{{ index + 1 }}</router-link>
              </h4>
              <div class="designation">{{ item.columnName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import api from '@/api/index.js'
export default {
  name: 'tendersCommon',
  data() {
    return {
      loading: false,
      dataList: [],
      URLTYPE: this.$store.screen.URLTYPE,
      type: 'Bidding', //
      Page: {
        total: 5,
        currentPage: 1,
        pageSize: 10,
        orders: [],
      },
      dataList1: [],
      dataList2: [],
      dataList3: [],
      dataListAll: [],
    }
  },
  // watch: {
  //   type:{
  // 		handle(newVal,oldVal){
  // 			this.dataList = this['dataList'+newVal]
  // 		},
  // 		deep:true,
  // 		immediate:true,
  // 	}
  // },
  created() {},
  mounted() {
    // this.refreshList()
  },
  methods: {
    link_to(id) {
      this.$router.push({ path: '/tendersdetails/' + id })
    },
    changeType(type) {
      this.type = type
      if (type == 'all') {
        this.init()
      } else {
        this.refreshList()
      }
    },
    currentChangeHandle(currentPage, pageSize) {
      console.log(265, currentPage, pageSize)
      this.Page.currentPage = currentPage
      this.Page.pageSize = pageSize
      this.changeType(this.type)
    },
    init() {
      this.loading = true
      this.dataList1 = []
      this.dataList2 = []
      this.dataList3 = []
      let func1 = api
        .webList({
          pageNo: this.Page.currentPage,
          pageSize: this.Page.pageSize,
          isPublished: '1', //是发布的
          columnName: 'Bidding Information', //是招标列表
          // type:'1'//代表正在进行招标的数据
        })
        .then((res) => {
          this.dataList1 = res.page.list
        })

      let func2 = api
        .webList({
          pageNo: this.Page.currentPage,
          pageSize: this.Page.pageSize,
          isPublished: '1', //是发布的
          columnName: 'Bidding Information', //是招标列表
          postponeType: '2', //代表延期公告的数据
          // type:'1'//代表正在进行招标的数据
          // 需要加一个查询延期公告的字段
        })
        .then((res) => {
          this.dataList2 = res.page.list
        })
      let fun3 = api
        .webList({
          pageNo: this.Page.currentPage,
          pageSize: this.Page.pageSize,
          isPublished: '1', //是发布的
          columnName: 'History Bidding Information', //是招标列表
          // type:'1'//代表正在进行招标的数据
        })
        .then((res) => {
          this.dataList3 = res.page.list
        })
      Promise.all([func1, func2, fun3])
        .then((values) => {})
        .then((res) => {
          console.log('都加载完了')
          this.dataList = this.dataList1.concat(this.dataList2).concat(this.dataList3)
          this.dataListAll = this.dataList
          this.Page.total = 10
          // this.carousel()
        })
        .catch((err) => {
          this.$message.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    indexinit(data, type) {
      this.type = type ? type : 'Bidding'
      this.refreshList(data)
    },
    refreshList(data) {
      this.loading = true
      this.dataList1 = []
      this.dataList2 = []
      this.dataList3 = []
      if (data) {
        this.dataList1 = data.page.list
        this.Page.total = data.page.count
        this.dataList = data.page.list
        this.loading = false
      } else {
        if (this.type == 'Bidding') {
          api
            .webList({
              pageNo: this.Page.currentPage,
              pageSize: this.Page.pageSize,
              isPublished: '1', //是发布的
              columnName: 'Bidding Information', //是招标列表
              // type:'1'//代表正在进行招标的数据
            })
            .then((res) => {
              this.dataList1 = res.page.list
              this.Page.total = res.page.count
              this.dataList = this.dataList1
              this.loading = false
            })
        } else if (this.type == 'PostponeAnnouncement') {
          api
            .webList({
              pageNo: this.Page.currentPage,
              pageSize: this.Page.pageSize,
              isPublished: '1', //是发布的
              columnName: 'Bidding Information', //是招标列表
              postponeType: '2', //代表延期公告的数据
              // type:'1'//代表正在进行招标的数据
              // 需要加一个查询延期公告的字段
            })
            .then((res) => {
              this.dataList2 = res.page.list
              this.Page.total = res.page.count
              this.dataList = this.dataList2
              this.loading = false
            })
        } else if (this.type == 'History') {
          api
            .webList({
              pageNo: this.Page.currentPage,
              pageSize: this.Page.pageSize,
              isPublished: '1', //是发布的
              columnName: 'History Bidding Information', //是招标列表
              // type:'1'//代表正在进行招标的数据
            })
            .then((res) => {
              this.dataList2 = res.page.list
              this.Page.total = res.page.count
              this.dataList = this.dataList2
              this.loading = false
            })
        }
      }
    },
    carousel() {
      this.$nextTick(() => {
        if ($('.team-carousel').length) {
          $('.team-carousel').owlCarousel({
            loop: false,
            margin: 10,
            nav: true,
            smartSpeed: 500,
            autoplay: 5000,
            autoplayTimeout: 5000,
            navText: [
              '<span class="icon flaticon-back"></span>',
              '<span class="icon flaticon-next"></span>',
            ],
            responsive: {
              0: {
                items: 1,
              },
              600: {
                items: 2,
              },
              768: {
                items: 3,
              },
              1024: {
                items: 3,
              },
              1200: {
                items: 4,
              },
            },
          })
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
.tab-title {
  font-weight: 700;
  font-size: 30px;
  color: #222222;
	margin-bottom: 40px;
}
.hide {
  display: none !important;
}
.sidebar-page-container {
  padding: 0;
}
:deep(.pagination) {
  padding: 0 !important;
}

.team-section {
  background: inherit;
}
.owl-carousel.owl-drag .owl-item {
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-top: none;
  font-family: 'Manjari', sans-serif;
  box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.1);
}
// .owl-carousel.owl-loaded{
// 	display: flex;
// 	justify-content: center;
// }

:deep(.event-block:hover) {
  cursor: pointer;
  .inner-box:before {
    background: rgb(0, 170, 85, 0.07);
  }
  h3 {
    color: #00aa55;
  }
}

:deep(.events-list) {
  min-height: 630px;
  .event-block {
    // margin-bottom: 10px;
    // border: 1px solid rgba(0, 0, 0, 0.1);
    // border-radius: 5px;
  }
  .event-block:nth-of-type(2n) {
    background: rgb(0, 170, 85, 0.05);
  }
  .event-block:last-child {
    margin-bottom: 40px;
  }
  .event-block .inner-box:before {
    left: 0;
  }
  .inner-box:after {
    left: 10px;
    border: none;
  }
  .inner-box {
    padding: 0;
    .content-box {
      padding: 8px 12px;
      min-height: 65px;
      position: relative;

      .icon-New {
        z-index: 1;
        position: absolute;
        top: 5px;
        right: 0px;
        font-size: 33px;
        // color: #ea9518;
        color: #ff8400;
        // color: #f24f00;
      }

      .public-date {
        position: absolute;
        top: -20px;
        right: 15px;
        opacity: 0.2;
      }

      .content {
        padding: 0;

        .cat-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
					flex-wrap: wrap;
          margin-bottom: 5px;
          padding-right: 20px;
        }
      }

      h3 {
        margin: 0;
        font-size: 15px;
				font-weight: 500;
        line-height: 1;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .location {
        display: flex;
        align-items: center;
        justify-content: space-between;
				min-width: 214px;
      }
    }
  }
}

.time-zone {
  // background: linear-gradient(135deg, #00aa55 0%, #00aa55 100%);
  color: #7f8c8d;
  // padding: 4px 16px;
  // border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  // max-width: 50%;
  text-align: center;
  // display: inline-block;
  display: flex;
  min-width: 300px;
}

.green {
  color: #00aa55;
  /* 高亮绿色 */
}

.red {
  color: #e74c3c;
  /* 红色高亮 */
}

// .history {
//   .time-zone {
//     background: linear-gradient(135deg, #7f8c8d 0%, #7f8c8d 100%);
//   }
//   .green {
//     color: #7f8c8d;
//   }

//   .red {
//     color: #7f8c8d;
//   }
// }

.sidebar .services-widget .links li {
  .icon {
    line-height: 70px;
    font-size: 36px;
  }
  div {
    position: relative;
    display: block;
    padding: 28px 0px 22px;
    line-height: 30px;
    padding-left: 80px;
    min-height: 80px;
    color: #222222;
    font-weight: 700;
    box-shadow: 0px 25px 30px 0px rgba(0, 0, 0, 0.07);
    transition: all 500ms ease;
    -moz-transition: all 500ms ease;
    -webkit-transition: all 500ms ease;
    -ms-transition: all 500ms ease;
    -o-transition: all 500ms ease;
  }
	.ttl{
		font-weight: 500;
	}
}
.sidebar .services-widget .links li.current,
.sidebar .services-widget .links li:hover {
  cursor: pointer;
  background: #00aa55;
  color: #fff;
	.ttl,
  .icon {
    color: #fff;
  }

}

.read-more {
  font-size: 17px;
}

.read-more:hover {
  cursor: pointer;
  transform: translateY(-20%);
  a {
    color: #00aa55 !important;
  }
}
</style>
